import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { activateAppSaving, deactivateAppSaving } from './actions'

const mapDispatchToProps = {
  activateAppSavingAction: activateAppSaving,
  deactivateAppSavingAction: deactivateAppSaving
}

export default
@connect(null, mapDispatchToProps)
class AppSavingActivator extends Component {
  static propTypes = {
    activateAppSavingAction: PropTypes.func.isRequired,
    deactivateAppSavingAction: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { activateAppSavingAction } = this.props
    activateAppSavingAction(this)
  }

  componentWillUnmount() {
    const { deactivateAppSavingAction } = this.props
    deactivateAppSavingAction(this)
  }

  render() {
    return null
  }
}
